import styled, {css} from 'styled-components'
import {ModalHeader, ModalParagraph} from '@components/ui/modal-atoms/ModalAtoms.tsx'

export const StyledModalHeader = styled(ModalHeader)(
    ({theme: {spacing}}) => css`
        display: flex;
        flex-direction: column;
        gap: ${spacing * 2}px;
    `
)

export const StyledModalParagraph = styled(ModalParagraph)(
    ({theme: {palette}}) => css`
        color: ${palette.neutral['500']};
        & b {
            font-weight: 500;
            color: ${palette.neutral['950']};
        }
    `
)

export const StyledFullName = styled(StyledModalParagraph)(
    ({theme: {spacing, palette}}) => css`
        padding-left: ${spacing}px;
        font-weight: 500;
        color: ${palette.neutral['950']};
        &:before {
            content: '• ';
        }
    `
)
